import { render } from "./IndexReviewCarouselItem.vue?vue&type=template&id=5ca02bc4"
import script from "./IndexReviewCarouselItem.vue?vue&type=script&lang=js"
export * from "./IndexReviewCarouselItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__